import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addOneStaff } from '../../../../../actions/staff';
import Row from '../../../../../components/Basic/Blocks/Row';
import Button from '../../../../../components/Basic/Buttons/Button';
import H2 from '../../../../../components/Basic/WrapsStyle/H/H2';
import { TYPE_BUTTONS, USERS_LIST } from '../../../../../constans';

import UserApi from '../../../../../API/user/user-api';
import PopUp from '../../../../../components/Basic/Blocks/PopUp';
import Input from '../../../../../components/Basic/Inputs/Base';
import Select from '../../../../../components/Basic/Inputs/Select';
import styles from './styles.module.scss';

const CreateUserPackagerPopUp = ({ close = () => { } }) => {
  const dispatch = useDispatch();
  const [data, setData] = useState({
    login: '',
    name: '',
    role: "packer",
    password: '',
  });

  const [valid, setValid] = useState({
    login: '',
    password: '',
  });

  const disabled_button = !(data.name.length > 0 && data.password.length > 0 && data.login.length > 0);

  const validate = () => {
    if (!disabled_button) {
      return true;
    } else {
      setValid({
        name: data.name.length > 0 ? '' : 'Заполни поле ',
        login: data.login.length > 0 ? '' : 'Заполни поле ',
        password: data.password.length > 0 ? '' : 'Заполни поле ',
      });
      return false;
    }
  };

  const clickAdd = () => {
    if (validate()) {
      UserApi.addUser({ data })
        .then((res) => {
          dispatch(addOneStaff(res.user));
          close();
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2>Добавить нового сотрудника</H2>
      <Input
        value={data.login}
        error={valid.login}
        label="Логин"
        width="80%"
        onChange={(v) => setData({ ...data, login: v })}
      />
      <Input
        value={data.password}
        error={valid.password}
        label="Пароль"
        width="80%"
        onChange={(v) => setData({ ...data, password: v })}
      />

      <Input
        value={data.name}
        error={valid.name}
        label="Имя"
        width="80%"
        onChange={(v) => setData({ ...data, name: v })}
        style={{ marginBottom: '15px' }}
      />
      <Select
        select={data.role}
        label="Должность"
        width="300px"
        onSelect={(v) => setData({ ...data, role: v })}
        list={['packer']}
        valueFn={(v) => USERS_LIST[v].name}
      />

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{ marginRight: '20px' }}
          disabled={disabled_button}
          onClick={disabled_button ? () => { } : clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateUserPackagerPopUp;
